module.exports = __webpack_public_path__ + "img/GCAnalysis.59aef59a.png";